import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UserService, ProductService, EventBusService } from "@mypxplat/xplat/core";
import { Product } from "@mypxplat/xplat/core";
import { ProductTileBaseComponent } from "@mypxplat/xplat/features";
import { AppService, AvoService } from "@mypxplat/xplat/web/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "myp-product-tile",
  templateUrl: "product-tile.component.html",
})
export class ProductTileComponent extends ProductTileBaseComponent implements OnInit {
  @Input() product: any;
  @Input() image: string;
  @Input() buttons: Array<any>;
  @Input() title: string;
  @Input() description: string;
  @Input() productLink: string;
  @Input() registerProductTile: boolean;
  @Input() showDate: boolean = true;
  @Output() tileClicked: EventEmitter<any> = new EventEmitter();
  @Output() registerProductClicked: EventEmitter<any> = new EventEmitter();
  public ownedProductID: any;
  public samplePrefix = "https://pae-web.presonusmusic.com/uploads/products/";

  constructor(
    public userService: UserService,
    public productService: ProductService,
    public appService: AppService,
    public translate: TranslateService,
    public eventBusService: EventBusService,
    public avoService: AvoService
  ) {
    super(userService);
  }

  ngOnInit() {
    if (this.product) {
      if (this.product.nav_id && this.productService.productsByErpIDs[this.product.nav_id]) {
        this.ownedProductID = this.productService.productsByErpIDs[this.product.nav_id].id;
      } else if (!this.productLink && this.product.url) {
        this.productLink = this.product.url;
      } else if (!this.productLink && this.product.permalink_products) {
        this.productLink = "https://shop.presonus.com/" + this.product.permalink_products;
      }

      if (this.product.title_products) {
        this.title = this.product.title_products;
        this.description = this.product.shortdesc_products;

        if (this.product.images && this.product.images.length) {
          this.image = "https://www.presonus.com/uploads/products/media/images/" + this.product.images[0].file_productimages + "_thumbnail.png";
        }
      } else {
        this.title = this.product.product.title;
        this.description = this.product.product.shortDescription;
        this.image = this.product.product.imageUrl;
      }
    }
  }

  playSample(url) {
    this.eventBusService.emit(this.eventBusService.types.playAudio, {
      url: this.samplePrefix + url,
      filename: this.product.product.title,
    });
  }

  downloadInstaller(product) {
    this.productService.getProductDetails(product).subscribe((detail: any) => {
      let download;
      if (this.appService.os == "mac") {
        download = detail.product_data.product.downloads.installers.mac[0];
        this._getTokenizedInstaller(download);
      } else {
        if (detail.product_data.product.downloads.installers.win64) {
          download = detail.product_data.product.downloads.installers.win64[0];
          this._getTokenizedInstaller(download);
        } else {
          download = detail.product_data.product.downloads.installers.win[0];
          this._getTokenizedInstaller(download);
        }
      }
    });
  }

  private _getTokenizedInstaller(dl) {
    if (dl.tokenized) {
      this.productService
        .getTokenizedUrl(
          dl.folder,
          dl.fileName,
          this.userService.appId == "mypresonus" ? "mypresonus" : "studio_one_plus",
          dl.product?.title || dl.title,
          dl.product?.id.toString() || dl.id.toString(),
          dl.fileName,
          parseInt(dl.contentLength),
          dl.version || dl.version_number
        )
        .subscribe({
          next: (result: any) => {
            window.open(result.url);
          },
          error: (error) => {
            this.appService.alertError(error);
          },
        });
    } else {
      window.open(dl.url);
    }
  }
}
